// Restored from V1.03.04: mobile sticky visibility only. Content stays server-rendered.
(() => {
  const initMobileSticky = () => {
    if (!document.body.classList.contains('template-product--new-product-page')) return;

    const stickyBars = Array.from(document.querySelectorAll('sticky-atc'));
    const mainCta = document.querySelector(
      '.main-product-information .add-to-cart-button, .main-product-information product-form-component .product-form__submit'
    );
    if (!stickyBars.length || !mainCta) return;

    let scheduled = false;
    const updateStickyBar = () => {
      scheduled = false;
      if (window.matchMedia('(min-width: 750px)').matches) {
        stickyBars.forEach((bar) => bar.classList.remove('fv-sticky-visible'));
        return;
      }

      const ctaRect = mainCta.getBoundingClientRect();
      const ctaIsVisible = ctaRect.bottom > 0 && ctaRect.top < window.innerHeight;
      const pageBottom = window.scrollY + window.innerHeight;
      const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      const nearFooter = pageBottom >= documentHeight - 80;
      const shouldShow = !ctaIsVisible && !nearFooter;

      stickyBars.forEach((bar) => bar.classList.toggle('fv-sticky-visible', shouldShow));
      const visibleHeight = shouldShow ? Math.max(...stickyBars.map((bar) => bar.offsetHeight), 0) : 0;
      document.body.style.setProperty('--sticky-atc-height', `${visibleHeight}px`);
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateStickyBar);
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    scheduleUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileSticky, { once: true });
  } else {
    initMobileSticky();
  }
})();
